const CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID || ''
const AUTHORITY = process.env.REACT_APP_SSO_AUTHORITY || ''

export const msalConfig = {
  auth: {
    clientId:              CLIENT_ID,
    authority:             AUTHORITY,
    redirectUri:           window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation:          'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}